import axios from "axios";
import { logout } from "../lib/auth";

import { EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";

// 外部エントリーフォーム - 外部サービス一覧取得
export async function getOutsideEntryFormServices(id: string) {
  try {
    const path = "outsideEntryFormServices";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return { sudDatas: response.data.fetch_data };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}
// 外部エントリーフォーム - 外部サービス詳細取得
export async function getOutsideEntryFormService(id: string) {
  try {
    const path = "outsideEntryFormService";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    return response.data.detail_data[0];
  } catch (error) {}
}
// 外部エントリーフォーム - 外部サービス詳細編集
export async function putOutsideEntryFormService(editData: EditDataDifine) {
  try {
    const path = "outsideEntryFormService";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
      payment_method_id: editData.payment_method_id,
    };
    const response = await axios.put(CONST.apiUrl2 + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// 外部エントリーフォーム - 外部サービス登録
export async function postOutsideEntryFormService(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "outsideEntryFormService";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl2 + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}

// 外部エントリーフォーム - 外部サービス削除
export async function deleteOutsideEntryFormService(id: string) {
  try {
    const path = "outsideEntryFormService";
    const params = { id };
    const response = await axios.delete(CONST.apiUrl2 + path, {
      params,
    });
    return response.data.delete;
  } catch (error) {
    // logout();
  }
}
